var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCalendarRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 22.5,
    height: 22.5,
    rx: 11.25,
    fill: "white",
    stroke: "#2297FF",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1.30818,
    height: 7.8491,
    rx: 0.654092,
    transform: "matrix(0.731055 -0.682319 0.731055 0.682318 9.12305 7.53711)",
    fill: "#2297FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1.30818,
    height: 7.8491,
    rx: 0.654092,
    transform: "matrix(-0.731055 -0.682318 0.731055 -0.682319 10.0791 17.356)",
    fill: "#2297FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCalendarRightArrow);
export default __webpack_public_path__ + "static/media/ic_calendar_right_arrow.a4b1d324bda3ea7710d772461df792c1.svg";
export { ForwardRef as ReactComponent };